import { LAYOUTS } from '@voltmoney/types';
import { ROUTE } from '../../../routes';
import { ACTION } from './types';
import { goBack, needHelp } from './actions';
import { WIDGET } from "@voltmoney/schema";
import { getForeClosureDetails } from "../../../configs/utils";
export const template = (height, creditResponseData) => ({
    layout: {
        id: ROUTE.REPAYMENT_CHARGES_DETAILS_PAGE,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            {
                id: 'repaymentChargesDetailsPage',
                type: WIDGET.REPAYMENT_CHARGES_DETAILS_PAGE
            }
        ],
    },
    datastore: {
        repaymentChargesDetailsPage: {
            height: height,
            bankData: creditResponseData,
            goBackAction: {
                routeId: ROUTE.REPAYMENT_CHARGES_DETAILS_PAGE,
                type: ACTION.GO_BACK,
                payload: {}
            },
            needHelpAction: {
                routeId: ROUTE.REPAYMENT_CHARGES_DETAILS_PAGE,
                type: ACTION.NEED_HELP,
                payload: {}
            }
        }
    },
});
export const repaymentChargesDetailMF = {
    onLoad: async ({ getHeight, network }) => {
        const getForeClosureData = await getForeClosureDetails(network);
        const creditResponseData = getForeClosureData;
        return Promise.resolve(template(getHeight(), creditResponseData));
    },
    actions: {
        [ACTION.GO_BACK]: goBack,
        [ACTION.NEED_HELP]: needHelp
    },
    clearPrevious: true,
};
